import { render, staticRenderFns } from "./SpinnerIcon.vue?vue&type=template&id=a630b48c&"
import script from "./SpinnerIcon.vue?vue&type=script&lang=js&"
export * from "./SpinnerIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports